<template>
  <div class="body home">
    <div class="wrapper_login">
      <div class="login">
        <h1><img src="../../static/img/logo_login.png" width="262" height="70" alt="SKY FOX"></h1>

        <div class="login_box" :class="{'error_box': invalidStatus > 0}">
          <template v-if="invalidStatus < 2">

            <template v-if="invalidStatus === 1">
              <h4>ユーザーIDまたはパスワードが不正です。</h4>
              <h5>※同じユーザー名で3回以上間違えるとアカウントがロックされます。</h5>
            </template>

            <div class="login_form">
              <p>ユーザー名</p>
              <input v-model="username" class="input_text" maxlength="30" type="text" required/>
            </div>
            <div class="login_form">
              <p>パスワード</p>
              <input v-model="password" class="input_text" maxlength="30" type="password" required>
            </div>
            <div style="display: flex; width: 320px; height: 50px;">
              <button class="btn btn_standard" type="button" @click="login">ログイン</button>
            </div>
          </template>

          <template v-else-if="invalidStatus > 1">
            <template v-if="invalidStatus === 2">
              <h2>アカウントがロックされています。<br>管理者に連絡してください。</h2>
            </template>

            <template v-if="invalidStatus === 3">
              <h2>ご契約がないためサービスをご利用いただけません。<br>ご不明な場合は担当者にご連絡ください。</h2>
            </template>

            <div class="support">
              <p class="mail">support-skyfox@sxi.co.jp</p>
              <p>サービス時間：平日 10:00～18:00</p>
            </div>

            <button class="btn btn_standard js-link" type="button" @click="invalidStatus = 0">ログインへ戻る</button>

          </template>
        </div>

        <div style="font-size: 0.6rem; margin-bottom: 2rem;">
          <p>ご利用推奨ブラウザ：<b>Google Chrome</b></p>
          <p style="font-size: 0.6rem; margin-bottom: 0.6rem;">ご利用対応ブラウザ：<b>Microsoft Edge、Mozilla Firefox</b></p>
          <span>※上記のWebブラウザ以外をご利用の場合、サービスがご利用頂けない場合がございます。</span>
        </div>

        <h2><img src="../../static/img/logo_sx.png" width="200" height="38" alt="SecondXight"></h2>
        <p class="copyright">Copyright © 2019 SecondXight, Inc. All Rights Reserved</p>

      </div>
    </div>
  </div>
</template>

<script>

import WebApiClient from '../api/web'

export default {
  name: 'LoginView',
  data () {
    return {
      username: '',
      password: '',
      invalidStatus: 0
    }
  },
  computed: {
    isIdle () {
      return this.$route.query.isIdle
    }
  },
  created () {
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && this.username && this.password) {
        this.login()
      }
    })
  },
  methods: {
    login () {
      const $parent = this
      WebApiClient.login($parent, {
        username: $parent.username,
        password: $parent.password
      }).then(response => {
        const result = response.data

        if (result.hasOwnProperty('invalidStatus')) {
          this.invalidStatus = result.invalidStatus
        } else {
          $parent.$session.start()
          $parent.$session.set('USER_ID', result.userId)
          $parent.$session.set('USER_NAME', result.userName)
          $parent.$session.set('CUSTOMER_NAME', result.customerName)
          $parent.$session.set('API_URL', result.apiUrl)
          $parent.$session.set('API_KEY', result.apiKey)
          $parent.$session.set('API_SECRET', result.apiSecret)
          $parent.$session.set('SUPPORT_ENABLED', result.supportEnabled)
          $parent.$session.set('AUTH_TOKEN', result.authToken)

          $parent.$router.push('/')
        }

      })
    }
  }
}
</script>

<style scoped>

  /*------------------------------------------

    旧形式のcssを引っ張ってきたので出来れば現行のものベースに書き直したい

  ------------------------------------------*/

  * {
    margin: 0;
    padding: 0;
    background-position: center center;
    box-sizing: border-box;
    outline: none;
  }

  .dtp-picker * {
    line-height: 1;
  }

  img {
    height: auto;
  }

  html {
    height: 100%;
    min-height: 100%;
  }

  body {
    font-family: "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", "Meiryo", sans-serif;
    color: #394445;
    font-size: 16px;
    margin: auto;
    text-align: left;
    word-break: break-all;
    line-height: 2;
    background: -moz-linear-gradient(top, #7bade7, #bde0eb) fixed;
    background: -webkit-linear-gradient(top, #7bade7, #bde0eb) fixed;
    background: linear-gradient(to bottom, #7bade7, #bde0eb) fixed;
    min-height: 100%;
    height: 100%;
  }

  .body {
    padding: 12px 60px 50px 60px;
    height: 100%;
    overflow-y: auto;
  }

  .body.home {
    padding: 0;
  }

  li {
    list-style: none;
  }

  img {
    height: auto;
  }

  a {
    text-decoration: none;
    color: #2456d4;
    -webkit-transition: 0.2s ease-in-out;
    -moz-transition: 0.2s ease-in-out;
    -o-transition: 0.2s ease-in-out;
    transition: 0.2s ease-in-out;
    text-decoration: underline;
  }

  .side_column a {
    text-decoration: none;
  }

  .side_column a:hover {
    text-decoration: underline;
  }

  a:visited {
    text-decoration: none;
    color: #2456d4;
  }

  a:hover {
    text-decoration: none;
    color: #2456d4;
  }

  a img {
    -webkit-transition: 0.2s ease-in-out;
    -moz-transition: 0.2s ease-in-out;
    -o-transition: 0.2s ease-in-out;
    transition: 0.2s ease-in-out;
  }

  a:hover img {
    opacity: 0.8;
  }

  img {
    border: 0;
    vertical-align: top;
  }

  h1, h2, h3, h4, h5 {
    font-weight: normal;
    font-size: 1.00rem;
  }

  strong {
    color: #d8243e;
  }

  table {
    border-collapse: collapse;
  }

  td, th {
    text-align: left;
  }

  .copyright {
    color: #fff;
    font-size: 0.63rem;
    margin: 10px auto 50px auto;
    width: 100%;
    max-width: 1400px;
    min-width: 980px;
    text-align: right;
  }

  /*------------------------------------------

    ボタン

  ------------------------------------------*/

  a.btn,
  .btn {
    padding: 14px 5px;
    display: inline-block;
    text-align: center;
    border-radius: 2px;
    border: 1px solid #2456d4;
    text-decoration: none;
    line-height: 2;
    width: 320px;
    -webkit-transition: 0.2s ease-in-out;
    -moz-transition: 0.2s ease-in-out;
    -o-transition: 0.2s ease-in-out;
    transition: 0.2s ease-in-out;
    margin: 0 14px;
    cursor: pointer;
  }

  .home .btn {
    padding: 8px 5px;
    margin: 0 0;
  }

  a.btn:hover,
  .btn:hover {
    background: #6ba7ef;
    border: 1px solid #6ba7ef;
    color: #fff;
  }

  a.btn_standard,
  .btn_standard {
    background: #2456d4;
    color: #fff;
    font-size: 1.00rem;
  }

  /*------------------------------------------

    ログイン/エラー

  ------------------------------------------*/

  .wrapper_login {
    width: 100%;
    height: 100%;
  }

  .login {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -18rem;
    margin-left: -240px;
    width: 480px;
    text-align: center;
  }

  .login h1 {
    margin: 0 0 34px 0;
  }

  .login_box {
    background: rgba(255, 255, 255, 0.4);
    padding: 60px 80px;
    margin: 0 0 2rem 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .login_form {
    background: #e3ebf4;
    display: flex;
    width: 320px;
    margin: 0 0 20px 0;
  }

  .login_form p {
    width: 120px;
    font-size: 0.75rem;
    font-weight: bold;
    padding: 7px 10px;
  }

  .login_form .input_text {
    height: 40px;
    border: none;
  }

  .login .copyright {
    width: 100%;
    text-align: center;
    max-width: none;
    min-width: auto;
  }

  .error_box {
    padding: 60px 40px;
  }

  .error_box h1,
  .error_box h2,
  .error_box h3,
  .error_box h4,
  .error_box h5 {
    color: #d8243e;
  }

  .error_box h1 {
    font-size: 2.80rem;
    font-weight: bold;
    margin: 0 0 0 0;
    line-height: 1;
  }

  .error_box h2 {
    font-weight: bold;
    margin: 10px auto 20px auto;
  }

  .error_box h3 {
    font-size: 1.50rem;
    margin: 0 0 20px 0;
  }

  .error_box h4 {
    font-weight: bold;
    font-size: 1.00rem;
    margin: 0 0 0 0;
  }

  .error_box h5 {
    font-size: 0.74rem;
    margin: 0 0 20px 0;
  }

  .error_box .mail:first-child {
    display: inline;
    text-align: left;
    width: auto;
    margin: 0 auto 20px auto;
    font-size: 1.25rem;
  }

  .error_box .support p {
    margin: 10px 0 20px 0;
    font-size: 0.88rem;
  }

  .error_box .support {
    width: auto;
  }

  .dz-details {
    position: relative;
  }

  .dz-cancel {
    position: absolute;
    top: 0;
    right: 0;
  }

  .dz-size > strong {
    color: #000;
    font-weight: normal;
  }

  .title_modal + .selectlist_modal {
    border-top: 1px solid #c0d5ef;
  }

  .btn_batch {
    position: fixed;
    top: 40%;
    display: block;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    font-size: 1.30rem;
    margin-left: -30px;
  }

  @media screen and (min-width: 1700px) {
    .btn_batch {
      margin-left: -100px;
    }
  }

  .top_no_padding {
    padding-top: 0;
  }

  .bottom_no_padding {
    padding-bottom: 0;
  }

  .top_no_margin {
    margin-top: -1px;
  }

  .bottom_no_margin {
    margin-bottom: 0;
  }

  .table_container {
    max-height: 640px;
    margin: 40px 0 0 0;
    overflow: auto;
  }

  .table_container > .table_wrapper {
    width: 0;
    min-width: 100%;
  }

  .table_container table {
    margin: 0;
  }

  .btn_singleline {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .table_row_singleline tr > th,
  .table_row_singleline tr > td {
    white-space: nowrap;
  }

  .credit_item {
    margin: 0 0 10px 0;
  }

  .credit_item .credit_source {
    font-size: 0.75rem;
  }

  .diagram_line_color_blue {
    background-color: #2456d4;
  }

  .diagram_line_color_red {
    background-color: #d8243e;
  }

  .diagram_line_color_green {
    background-color: #10be29;
  }

  .diagram_line_color_yellow {
    background-color: #dea211;
  }

  .diagram_line_color_gray {
    background-color: #6b6c76;
  }

  .diagram_line_color_l_blue {
    background-color: #2498d4;
  }

  .diagram_line_color_l_red {
    background-color: #b93ced;
  }

  .diagram_line_color_l_green {
    background-color: #de6311;
  }

  .diagram_line_color_l_yellow {
    background-color: #aa9650;
  }

  .diagram_line_color_navy {
    background-color: #7b50e6;
  }

  .diagram_line_color_mint {
    background-color: #0d94a0;
  }

  .diagram_bar_color_blue {
    background-color: #86C7F5;
  }

  .diagram_bar_color_red {
    background-color: #ff7d98;
  }

  .diagram_bar_color_dark_red {
    background-color: #ff305c;
  }

  .login.maintenance_box {
    width: 700px;
    margin-left: -350px;
  }

  .maintenance_box > h1 {
    font-weight: bold;
    font-size: 1.30rem;
  }

  .maintenance_box > .support {
    margin-top: 34px;
  }

  .suffix_label {
    margin-left: 6px;
  }

</style>



// WEBPACK FOOTER //
// src/views/login.vue